// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import axios from "../../utils/AxiosInstance";
// import "./auth.css";

// const ForgotPassword = () => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const initialValues = {
//     email: "",
//   };

//   const validationSchema = Yup.object({
//     email: Yup.string()
//       .email("Invalid email format")
//       .required("Email is required"),
//   });

//   const handleSendOtp = async (values, { setSubmitting }) => {
//     setLoading(true);
//     try {
//       const res = await axios.post("/auth/admin/forgot-password", {
//         email: values.email,
//       });

//       if (res.status === 200) {
//         localStorage.setItem("resetEmail", values.email);
//         toast.success(res.data.msg);
//         navigate("/reset-Password");
//       }
//     } catch (err) {
//       const msg = err.response?.data?.message || "Invalid";
//       toast.error(msg);
//     } finally {
//       setLoading(false);
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="login-container">
//       <h2>Forgot Password</h2>

//       <Formik
//         initialValues={initialValues}
//         validationSchema={validationSchema}
//         onSubmit={handleSendOtp}
//       >
//         {({ isSubmitting }) => (
//           <Form>
//             <Field
//               type="email"
//               name="email"
//               placeholder="Enter your email"
//               className="form-control"
//             />
//             <ErrorMessage
//               name="email"
//               component="div"
//               className="text-danger mb-2"
//               style={{ color: "red" }}
//             />

//             <button
//               type="submit"
//               disabled={isSubmitting || loading}
//               style={{ marginTop: "10px" }}
//             >
//               {loading ? "Please wait..." : "Sent OTP"}
//             </button>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default ForgotPassword;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "../../utils/AxiosInstance";
import "./auth.css";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const handleSendOtp = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const res = await axios.post("/auth/admin/forgot-password", {
        email: values.email,
      });

      if (res.status === 200) {
        localStorage.setItem("resetEmail", values.email);
        toast.success(res.data.msg);
        navigate("/reset-Password");
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Invalid";
      toast.error(msg);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">Forgot Password</div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSendOtp}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group">
                <Field
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  className="styled-field"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="error-text"
                />
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting || loading}
              >
                {loading ? "Please wait..." : "Send OTP"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
export default ForgotPassword;
